var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-item-container"},[_c('QuizItem',{attrs:{"description":_vm.description,"image":_vm.imageProcessed},on:{"click":_vm.openNext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }